const TwitterIcon = (props: { className?: string }) => {
  const { className } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      width="20"
      height="21"
    >
      <path d="M11.9 8.65 19.35 0h-1.77l-6.46 7.51L5.96 0H0l7.8 11.36L0 20.44h1.76L8.6 12.5l5.45 7.94H20L11.9 8.65Zm-2.4 2.81-.8-1.13-6.29-9h2.71l5.08 7.26.8 1.14 6.6 9.44h-2.72l-5.38-7.7Z" />
    </svg>
  );
};

export default TwitterIcon;
